module.exports = __webpack_public_path__ + "img/ml.b1f99384.svg";